exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".afm-star-container{width:100%;min-height:12px}.afm-star-container .star-img-container{display:-webkit-box;display:-ms-flexbox;display:flex;height:10px;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.afm-star-container .star-img-container .star-img{width:10px;margin-right:3px}.afm-star-container .star-img-container .star-text{color:#d8d8d8;font-size:12px;font-weight:600;font-family:Source Sans Pro}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-a6789384","scoped":false,"hasInlineConfig":false}!./node_modules/less-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/afm-star/afm-star.vue
// module id = TeY5
// module chunks = 1